
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/de/imprint",
      function () {
        return require("private-next-pages/de/imprint.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/de/imprint"])
      });
    }
  